import { gsap, Power3 as Ease } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { MotionPathPlugin } from 'gsap/MotionPathPlugin'
gsap.registerPlugin(MotionPathPlugin, ScrollTrigger)

export class MoveBoat {
  constructor() {
    const boat = document.getElementById('js-boat')
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '#js-tickets',
        start: '-50% top',
        end: '300px',
        scrub: true,
        // markers: true,
        toggleClass: { targets: '#js-boat', className: 'is-act' },
      },
    })

    tl.fromTo(
      '#js-boat',
      { x: '90vw', y: 0 },
      {
        ease: 'none',
        motionPath: {
          path: [
            { x: '70vw', y: '20vh' },
            { x: '20vw', y: '40vh' },
          ],
        },
      }
    )
  }
}

// animation = gsap.to("#element", {
//   scrollTrigger: {
//     trigger: "body",
//     markers: true,
//   },
//   duration: 10,
//   ease: "none",
//   immediateRender: true,
//   motionPath:
//    { path: [{
//      x: 0, y: '20vh'},
//      {xPercent: -20, y: '40vh'},
//      {xPercent: 40, y: '60vh' },
//      {xPercent: 0, y: '100vh'}]
//    }
// });
